import { isLocal } from '@lcsc-ui/utils/baseUrl';
import { doGet, doPost } from '@lcsc-ui/utils/request';

// client请求接口
let domain = 'lcscCartApiUrl';
if (isLocal) {
  domain = 'https://devcart.szlcsc.com';
}

// 正常加购
export function cartAddNormal(body) {
  return doPost(domain, `/cart/add/normal`, body);
}
// 立创订货/海外代购加购
export function cartAddOverseas(body) {
  return doPost(domain, `/async/add/overseas/brokage`, body);
}
// 校验mouse库存
export function getMouseStock(query) {
  return doGet(domain, `/get/mouse/stock`, query);
}
// 报价
export function specialAdd(body) {
  return doPost(domain, `/async/special/add`, body);
}
